module.exports = __webpack_public_path__ + "img/no-university.5f679ded.png";